// ─── Pied de version (Core) ───────────────────────────────────────
// Levé de MoPCal : nom + version + indicateur TRI-ÉTAT (jamais « à jour » par
// défaut : tant que la dernière version publiée est inconnue → « en attente… »).
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useApp } from '../app/AppContext';
import { versionAuMoins } from '../version';
import { ecouterDerniereVersion } from '../services/config';
import { useT } from '../i18n/LangueContext';

export const FOOTER_HEIGHT = 22;

export default function VersionFooter() {
  const UI = useUI();
  const t = useT();
  const app = useApp();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [derniere, setDerniere] = useState(null);

  useEffect(() => {
    const unsub = ecouterDerniereVersion(app.id, setDerniere);
    return () => unsub();
  }, [app.id]);

  const aJour = derniere ? versionAuMoins(app.version, derniere) : null;

  function appliquerMaj() {
    if (Platform.OS === 'web') {
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('maj', String(Date.now()));
        window.location.replace(u.toString());
      } catch { try { window.location.reload(); } catch {} }
      return;
    }
    try {
      const Updates = require('expo-updates');
      Updates.fetchUpdateAsync().then(() => Updates.reloadAsync()).catch(() => {});
    } catch {}
  }

  return (
    <View style={s.footer}>
      <Text style={s.txt} numberOfLines={1}>
        <Text style={s.nom}>{app.nom}</Text> · v{app.version} · © 2026
      </Text>
      {aJour === null  && <Text style={s.attente}> · {t('version.enAttente')}</Text>}
      {aJour === true  && <Text style={s.ajour}> · {t('version.aJour')} ✓</Text>}
      {aJour === false && (
        <TouchableOpacity onPress={appliquerMaj}>
          <Text style={s.dispo}> · {t('version.mettreAJour')} ⟳</Text>
        </TouchableOpacity>
      )}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  footer: {
    height: FOOTER_HEIGHT, flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    backgroundColor: UI.card, borderTopWidth: 1, borderTopColor: UI.border, paddingHorizontal: 8,
  },
  txt:     { fontSize: 9, color: UI.faint },
  nom:     { color: UI.accent, fontWeight: '700' },
  attente: { fontSize: 9, color: UI.faint },
  ajour:   { fontSize: 9, color: '#16A34A', fontWeight: '700' },
  dispo:   { fontSize: 9, color: '#D97706', fontWeight: '700' },
});
